import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../../common';
import { SapConfig, SapFlowGroup } from '../../../types/DataDelivery';

const useGenerateSapFlows = (orgId: string) => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (clientProjectId: string) => {
      const response = await axios.post<SapFlowGroup[]>(`data_wrangling/${clientProjectId}/sapflows/generate`);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['sapGroups'], { refetchInactive: true });
      },
    }
  );
};

export default useGenerateSapFlows;
